import * as React from 'react';
import { toSet } from '../../../utils/utils';
import { composeReducers, move, moveAll, selectItem, lazyLoad } from '../reducers/index';
import { useAsyncState } from './useAsyncState';
export function init({ source = [], target = [], selections = {
    source: [],
    target: [],
}, disabled = {
    source: [],
    target: [],
}, }) {
    if (!Array.isArray(selections.source)) {
        throw new Error('Initial selection "source" must be an array');
    }
    if (!Array.isArray(selections.target)) {
        throw new Error('Initial selection "target" must be an array');
    }
    return {
        source,
        target,
        selected: {
            source: toSet(selections.source),
            target: toSet(selections.target),
        },
        disabled: {
            source: toSet(disabled.source),
            target: toSet(disabled.target),
        },
    };
}
/**
 * useShuttleState allows you to own the state of the Shuttle. Pass in custom
 * data without trying to remember what prop needs to be set and with what params.
 * Save this result in a variable and spread ot back to `<Shuttle>`. Let the Shuttle
 * know:
 *
 * 1. What your data is
 * 2. What (if any) items need to be pre-selected
 * 3. What (if any) custom state reducers you want to process -- you can even override Shuttle state reducers here too!
 * @param initialState
 * @param initialSelections
 * @param reducers
 */
export function useShuttleState(initialState = {
    source: [],
    target: [],
}, initialSelections, disabled, reducers = {}) {
    const [shuttleState, setShuttleState] = React.useReducer(React.useCallback(composeReducers({ move, moveAll, selectItem, lazyLoad, ...reducers }), []), {
        ...initialState,
        // @ts-ignore
        disabled: disabled || {
            source: [],
            target: [],
        },
        selections: initialSelections || {
            source: [],
            target: [],
        },
    }, init);
    useAsyncState(initialState, setShuttleState);
    return { shuttleState, setShuttleState };
}
